import { useStoryblokState } from '@cinch-nx/data-storyblok'
import { Head } from '@cinch-nx/landing-ui-shared'
import { StoryblokRendererV2 } from '@cinch-nx/storyblok-utils'
import styles from './new-cars-offers.module.css'
import { NewCarsOffersProps } from './get-static-props'
import { NewCarsOffersStory } from './storyblok/storyblok'
import { landingStoryblokComponents } from '@cinch-nx/landing-ui-shared'

export const NewCarsOffers = ({ story, preview }: NewCarsOffersProps) => {
  const { content } = useStoryblokState<NewCarsOffersStory>({
    story,
    enableBridge: preview,
  })

  const SEO = content.SEO?.[0] ?? {}

  return (
    <>
      <Head
        {...SEO}
        fallbackTitle="New Cars Offers - cinch"
        fallbackDescription=""
      />
      <article className={styles.pageWrapper}>
        <StoryblokRendererV2
          block={content.body}
          components={{ slimWrapper: landingStoryblokComponents }}
        />
      </article>
    </>
  )
}
